/**
 * Instances page container
 */
import React from 'react';
import PropTypes from 'prop-types';
import MorePropTypes from 'airbnb-prop-types';
import { connect } from 'react-redux';
import { selectors as catalogSelectors } from 'dux/catalog';
import { selectors as selectorORv4 } from 'dux/instancesORv4';
import { actionCreators, selectors } from '../../../dux/instances';
import InstancesPage from './InstancesPage';
import { getInstancesORv4 } from '../../../dux/instancesORv4/actionCreators';

const propTypes = {
  getInstances: PropTypes.func.isRequired,
  getInstancesPoll: PropTypes.func.isRequired,
  getInstancesFromORv4: PropTypes.func.isRequired,
  ORv4ID: MorePropTypes.or([PropTypes.bool, PropTypes.string]).isRequired,
};

class InstancesPageContainer extends React.Component {
  componentDidMount() {
    const { getInstances, getInstancesFromORv4, ORv4ID } = this.props;
    getInstances();
    if (ORv4ID) {
      getInstancesFromORv4();
    }
  }

  render() {
    const { getInstances, ...props } = this.props;
    return <InstancesPage {...props} />;
  }
}

const mapStateToProps = (state) => ({
  catalog: catalogSelectors.getCatalogState(state),
  instancesState: selectors.getInstancesState(state),
  cockroachdbMultiInstanceIDs: selectors.getCockroachdbMultiInstanceIDs(state),
  instancesORv4: selectorORv4.getInstancesORv4(state),
  ORv4ID: selectorORv4.getORv4ID(state),
});

const mapDispatchToProps = {
  getInstances: actionCreators.getInstances,
  getInstancesPoll: actionCreators.getInstancesPoll,
  getInstancesFromORv4: getInstancesORv4,
};

InstancesPageContainer.propTypes = propTypes;

export default connect(mapStateToProps, mapDispatchToProps)(InstancesPageContainer);
